import Records from "features/inactive/components/Records";


export function TrashBin() {
	return <Records recordTitle="ASPX_206" />;
}
export function Archive() {
	return <Records recordTitle="ARCHIVE" />;
}
